module.exports = __webpack_public_path__ + "img/rafias.9bd46899.jpg";